import {
  DDL_GRAPHQL_ENDPOINT,
  DDL_API_KEY,
  DDL_DEACTIVATE_ENDPOINT as DDL_DEACTIVATE_ENDPOINT_CONFIG,
  DDL_DEACTIVATE_API_KEY as DDL_DEACTIVATE_API_KEY_CONFIG,
} from '../env/Configurations';

export const getDevices = (url) => {
  try {
    return fetch(url)
      .then((response) => response.json())
      .then((json) => json);
  } catch (err) {
    return err;
  }
};

export const updateDevice = (url, body) => {
  try {
    return fetch(url, {
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    })
      .then((response) => response.json())
      .then((json) => json);
  } catch (err) {
    return err;
  }
};

export const deleteDeviceAPI = (url, body) => {
  try {
    return fetch(url, {
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
    })
      .then((response) => response.json())
      .then((json) => json);
  } catch (err) {
    return err;
  }
};

const buildListDDLDevicesQuery = ({
  hotelId,
  deviceType,
  limit,
  nextToken,
  search,
  sortBy,
  sortOrder,
}) => `
  query MyQuery {
    listDDLDevices(
      input: {
        hotelId: "${hotelId}"
        deviceType: "${deviceType}"
        limit: ${limit}
        nextToken: "${nextToken}"
        search: "${search}"
        sortBy: "${sortBy}"
        sortOrder: "${sortOrder}"
      }
    ) {
      nextToken
      status
      items {
        deviceId
        deviceType
        endpointId
        expireDate
        guestName
        invitationCode
        reservationId
        roomNo
      }
    }
  }
`;

const DDL_DEACTIVATE_ENDPOINT = DDL_DEACTIVATE_ENDPOINT_CONFIG;
const DDL_DEACTIVATE_API_KEY = DDL_DEACTIVATE_API_KEY_CONFIG;

const buildDeactivateGuestDeviceQuery = ({
  hotelId,
  roomNo,
  lastName,
  firstName,
  deviceId,
  skipDoorKey = true,
  channel = 'ELEVATE',
}) => `
  query MyQuery {
    ddlDeactivateGuestDevice(
      input: {
        hotelId: "${hotelId}"
        roomNo: "${roomNo}"
        lastName: "${lastName}"
        firstName: "${firstName}"
        deviceId: "${deviceId}"
        skipDoorKey: ${skipDoorKey}
        channel: "${channel}"
      }
    ) {
      message
      status
    }
  }
`;

export const deactivateGuestDevice = async ({
  hotelId,
  roomNo = '',
  lastName = '',
  firstName = '',
  deviceId,
  skipDoorKey = true,
  channel = 'ELEVATE',
}) => {
  const query = buildDeactivateGuestDeviceQuery({
    hotelId,
    roomNo,
    lastName,
    firstName,
    deviceId,
    skipDoorKey,
    channel,
  });

  const response = await fetch(DDL_DEACTIVATE_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': DDL_DEACTIVATE_API_KEY,
    },
    body: JSON.stringify({ query }),
  });

  const result = await response.json();

  if (result.errors) {
    throw new Error(result.errors[0]?.message || 'GraphQL API error');
  }

  return result.data?.ddlDeactivateGuestDevice;
};

export const fetchMobileDevices = async ({
  hotelId,
  deviceType = '',
  limit = 10,
  nextToken = '',
  search = '',
  sortBy = '',
  sortOrder = '',
}) => {
  const query = buildListDDLDevicesQuery({
    hotelId,
    deviceType,
    limit,
    nextToken,
    search,
    sortBy,
    sortOrder,
  });

  const response = await fetch(DDL_GRAPHQL_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': DDL_API_KEY,
    },
    body: JSON.stringify({ query }),
  });

  const result = await response.json();

  if (result.errors) {
    throw new Error(result.errors[0]?.message || 'GraphQL API error');
  }

  const data = result.data?.listDDLDevices;
  const items = Array.isArray(data?.items) ? data.items : [];

  return {
    items,
    nextToken: data?.nextToken || null,
    status: data?.status,
  };
};
